import { useState } from "react";
import { Table, Space } from "antd";
import { Button } from "@mui/material";
import { Add as AddIcon } from "@mui/icons-material";
import AddAttributeModal from "./attributes-modal/AddAttributeModal";
import EditAttributeModal from "./attributes-modal/EditAttributeModal";

export default function AttributesTab({ attributes, setAttributes, entityId, onEntityRefresh }) {
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [editableAttr, setEditableAttr] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);

  // Filter out hidden attributes
  const visibleAttributes = attributes.filter(attr => !attr.is_hidden);


  // 🟢 Add new attribute(s)
  const handleAddSuccess = (newAttributes) => {
    if (!newAttributes) return;
    setAttributes((prev) => [...prev, ...newAttributes]);
    setIsAddModalOpen(false);
  };

  // ✏️ Edit attribute (UI only)
  const handleEdit = (index, attr) => {
    setEditIndex(index);
    setEditableAttr(attr);
    setIsEditModalOpen(true);
  };

  // Pagination
  const startIndex = (currentPage - 1) * pageSize;

  const paginatedData = visibleAttributes
    .slice(startIndex, startIndex + pageSize)
    .map((a, i) => ({
      key: startIndex + i,
      name: a.name,
      data_type: a.data_type,
      description: a.description,
      primary_col: a.primary_col,
      required_col: a.required_col,
      unique_col: a.unique_col,
      custom_col: a.custom_col,
    }));

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 8,
        }}
      >
        <h3>Attributes</h3>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          size="small"
          onClick={() => setIsAddModalOpen(true)}
        >
          Add Attribute
        </Button>
      </div>

      <Table
        dataSource={paginatedData}
        bordered
        size="small"
        pagination={{
          current: currentPage,
          pageSize,
          total: visibleAttributes.length,
          showSizeChanger: true,
          pageSizeOptions: [5, 10, 20, 50],
          onChange: (page, size) => {
            setCurrentPage(page);
            setPageSize(size);
          },
        }}
      >
        <Table.Column title="Name" dataIndex="name" width={220} />
        <Table.Column title="Type" dataIndex="data_type" width={150} />
        <Table.Column
          title="Description"
          dataIndex="description"
          width={300}
          render={(text) => <span title={text}>{text}</span>}
        />
        <Table.Column
          title="PK"
          dataIndex="primary_col"
          align="center"
          width={70}
          render={(checked) => (checked ? "✔️" : "")}
        />
        <Table.Column
          title="Required"
          dataIndex="required_col"
          align="center"
          width={90}
          render={(checked) => (checked ? "✔️" : "")}
        />
        <Table.Column
          title="Unique"
          dataIndex="unique_col"
          align="center"
          width={90}
          render={(checked) => (checked ? "✔️" : "")}
        />
        <Table.Column
          title="Custom"
          dataIndex="custom_col"
          align="center"
          width={90}
          render={(checked) => (checked ? "✔️" : "")}
        />
        <Table.Column
          title="Actions"
          align="center"
          width={160}
          render={(_, record, index) => (
            <Space>
              <Button
                size="small"
                onClick={() => handleEdit(startIndex + index, record)}
              >
                Edit
              </Button>
            </Space>
          )}
        />
      </Table>

      {/* Add Attribute Modal */}
      <AddAttributeModal
        open={isAddModalOpen}
        onClose={() => setIsAddModalOpen(false)}
        onSuccess={handleAddSuccess}
        entityId={entityId}
        existingAttributes={attributes}
      />

      {/* Edit Attribute Modal */}
      <EditAttributeModal
        open={isEditModalOpen}
        onClose={() => setIsEditModalOpen(false)}
        attribute={editableAttr}
        entityId={entityId}
        onSuccess={onEntityRefresh}
      />
    </>
  );
}
